<template>
  <div>
    <div class="dialog-footer">
      <el-button type="primary" @click="handlePrint">打 印</el-button>
    </div>
    <!-- 分页内容 -->
    <div v-for="(info, index) in list" :key="index" class="page-item">
      <div class="settlement-container">
        <div v-if="info.isActivity === 0" class="settlement-dashboard">
          <div class="settlement-title">{{ info.orgName }}</div>
          <div class="settlement-info">
            <div v-if="info.unattFlag === false">
              开单日期: {{ info.weightTime }}
            </div>
            <div v-if="info.unattFlag">销售日期: {{ info.saleTime }}</div>
            <div v-if="info.unattFlag === false">单号: {{ info.weightNo }}</div>
          </div>
          <div class="settlement-info">
            <div>客户名称: {{ info.customerName }}</div>
            <div>提货单号: {{ info.takeOrderNo }}</div>
          </div>
          <div class="settlement-customer">
            <div>成品名称: {{ info.itemName }}</div>
          </div>
          <div id="settlement-time" v-if="info.unattFlag === false">
            <div class="item settlement-time-a">
              <div>过皮时间: {{ info.tareWeightTime }}</div>
            </div>
            <div class="item settlement-time-b">
              <div>过毛时间: {{ info.grossWeightTime }}</div>
            </div>
            <div class="item settlement-time-c">
              <div>司磅员: {{ info.weightPerson }}</div>
            </div>
          </div>
          <img
            :src="info.dialogImageUrl"
            class="img-print"
            :class="info.unattFlag ? 'img-print_new' : 'img-print'"
            v-show="info.printVisible"
          />
          <div
            class="qrcode-print"
            :class="info.unattFlag ? 'qrcode-print-2' : 'qrcode-print'"
            ref="qrcode"
          ></div>
          <div id="settlement-detail">
            <div class="item settlement-item-b">
              <div>皮重（T）</div>
              <div class="item-result">{{ info.tareWeight }}</div>
            </div>
            <div class="item settlement-item-b">
              <div>毛重（T）</div>
              <div class="item-result">{{ info.grossWeight }}</div>
            </div>
            <div class="item settlement-item-c">
              <div>净重（T）</div>
              <div class="item-result">{{ info.actualWeight }}</div>
            </div>
            <div class="item settlement-item-d">
              <div>杂质含量（T）</div>
              <div class="item-result">{{ info.impurity }}</div>
            </div>
          </div>
          <div class="settlement-footer">
            <div class="settlement-footer-remarks">备注</div>
            <div class="settlement-footer-remarks-content">
              {{ info.remark ? '"销售提货"' + info.remark : '销售提货' }}
            </div>
            <div class="settlement-footer-number">车号:</div>
            <div class="settlement-footer-number-content">
              {{ info.plateNum }}
            </div>
          </div>
        </div>
        <div v-else-if="info.isActivity === 1" class="b-container">
          <title>过磅单</title>
          <div class="b-dashboard" v-for="item in bMap" :key="item.label">
            <div class="b-label">{{ item.label }}</div>
            <div class="b-value">{{ item.value }}</div>
          </div>
          <img :src="dialogImageUrl" class="img-print" v-show="printVisible" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import watermark from '@/common/watermark'
import QRCode from 'qrcodejs2'
export default {
  name: 'printBatch',
  data () {
    return {
      list: []
    }
  },
  computed: {},
  mounted () {
    watermark.out()
    this.getPrintSettlementBatch({
      takeOrderId: 0,
      takeOrderNos: this.$route.query.ids
    }).then((data) => {
      this.list = data
    })
  },
  updated () {
    this.showQrCode(this.$refs.qrcode)
  },
  methods: {
    ...mapActions(['getPrintSettlementBatch']),
    handlePrint () {
      window.print()
    },
    showQrCode (data) {
      for (let i = 0; i < this.list.length; i++) {
        let item = this.list[i]
        if (item.qrCodeUrl != null) {
          this.qrcode = new QRCode(data[i], {
            text: item.qrCodeUrl
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$black_line: 2px #000 solid;

/* 打印时分页 */
@media print {
  body {
    margin: 0;
    padding: 0;
  }

  .page-item {
    page-break-after: always;
    /* 每项结束后强制分页 */
  }

  /* 隐藏非打印内容 */
  button {
    display: none;
  }

  .dialog-footer {
    display: none;
  }
  /* 隐藏留言框和在线咨询 */
  .aff-im-root {
    display: none;
  }
}

@page {
  size: A5 landscape;
}

.settlement-container {
  font-size: 12px;
  text-align: center;

  .img-print {
    position: absolute;
    width: 140px;
    height: 140px;
    bottom: 150px;
    right: 350px;
  }

  .img-print_new {
    position: absolute;
    width: 140px;
    height: 140px;
    bottom: 110px;
    right: 350px;
  }

  .qrcode-print {
    position: absolute;
    width: 138px;
    height: 138px;
    bottom: 150px;
    right: 5px;
  }

  .qrcode-print-2 {
    position: absolute;
    width: 138px;
    height: 138px;
    bottom: 110px;
    right: 5px;
  }
}

.settlement-dashboard {
  width: 800px;
  height: auto;
  margin: 20px auto;
  position: relative;
  border: $black_line;

  div {
    height: 36px;
    line-height: 36px;
  }
}

.settlement-title {
  font-size: 20px;
  font-weight: bold;
  border-bottom: $black_line;
}

.settlement-info {
  font-size: 15px;
  display: flex;
  flex-flow: row nowrap;
  border-bottom: $black_line;

  div {
    text-align: left;
    flex: 0 0 50%;
  }
}

.settlement-customer {
  font-size: 15px;
  text-align: left;
  display: flex;
  flex-flow: row nowrap;

  div {
    text-align: left;
  }
}

#settlement-detail {
  font-size: 15px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 72px;

  .item {
    height: 72px;
  }
}

#settlement-time {
  font-size: 15px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  .item {
    text-align: left;
  }
}

.settlement-time-a {
  flex: 0 0 33%;
  border-top: $black_line;
  border-right: $black_line;
}

.settlement-time-b {
  flex: 0 0 33%;
  border-top: $black_line;
  border-right: $black_line;
}

.settlement-time-c {
  flex: 0 0 34%;
  border-top: $black_line;
}

.settlement-item-b {
  flex: 0 0 22%;
  border-top: $black_line;
  border-right: $black_line;
}

.settlement-item-c {
  flex: 0 0 22%;
  border-top: $black_line;
  border-right: $black_line;
}

.settlement-item-d {
  flex: 0 0 34%;
  border-top: $black_line;
}

.item-result {
  font-weight: bold;
  border-top: $black_line;
}

.settlement-footer {
  font-size: 15px;
  border-top: $black_line;
  display: flex;
  flex-flow: row nowrap;
}

.settlement-footer-remarks {
  flex: 0 0 22%;
  border-right: $black_line;
  font-weight: bold;
}

.settlement-footer-remarks-content {
  flex: 0 0 28%;
  border-right: $black_line;
}

.settlement-footer-number {
  flex: 0 0 10%;
  border-right: $black_line;
}

.settlement-footer-number-content {
  flex: 0 0 40%;
  font-weight: bold;
}

.b-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.b-container > title {
  display: flex;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}

.b-dashboard {
  width: 400px;
  display: flex;
  border: $black_line;
}

.b-dashboard + .b-dashboard {
  border-top: 0 none;
}

.b-label {
  flex: 1;
  border-right: $black_line;
  height: 30px;
  line-height: 30px;
}

.b-value {
  flex: 3;
  height: 30px;
  line-height: 30px;
}

.dialog-footer {
  margin-top: 60px;
}
</style>
